import { matchPath } from 'react-router-dom';

const DEFAULT_REDIRECT = '/';

const isKnownRoute = (path: string, validRoutePatterns: string[]): boolean => {
  const pathname = path.split('?')[0];
  return validRoutePatterns.some((pattern) => matchPath(pattern, pathname) !== null);
};

/** Safe redirect path from user input; falls back to '/' if invalid or external. */
export const getSafeRedirectPath = (path: string | null, validRoutePatterns: string[]): string => {
  if (!path) return DEFAULT_REDIRECT;
  if (!path.startsWith('/') || path.startsWith('//')) return DEFAULT_REDIRECT;
  if (/^\/\\/.test(path)) return DEFAULT_REDIRECT;

  try {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) return DEFAULT_REDIRECT;
  } catch {
    return DEFAULT_REDIRECT;
  }

  if (!isKnownRoute(path, validRoutePatterns)) return DEFAULT_REDIRECT;
  return path;
};
